/** anyDev service_url：`evnins-xxxx-8008.connect.anydev.woa.com`，去掉端口后即 gid。 */
export function parseGidFromServiceUrl(url) {
    const raw = url.trim();
    if (!raw)
        return '';
    const matched = raw.match(/([A-Za-z0-9-]+)-\d+\.connect\.anydev\.woa\.com/i);
    return matched?.[1] ?? '';
}
export function resolveContainerGid(gid, serviceUrl) {
    if (typeof gid === 'string' && gid.trim())
        return gid.trim();
    return parseGidFromServiceUrl(serviceUrl);
}
